import script from "./ModalExtendedLogin.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalExtendedLogin.vue?vue&type=script&setup=true&lang=js"

import "./ModalExtendedLogin.vue?vue&type=style&index=0&id=0ccf9f42&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ccf9f42"]])

export default __exports__